
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { IFaq } from '@/types';
import { Banner } from 'components/common/Banner';
import { BannerHalfBlurred } from 'components/common/BannerHalfBlurred';
import { Collapsable } from 'components/common/Collapsable';
import { FeatureCard } from 'components/common/FeatureCard';
import { HowItWorksStep } from 'components/common/HowItWorksStep';
import { InfoDot } from 'components/common/InfoDot';
import { Markdown } from 'components/common/Markdown';
import { Meta } from 'components/common/Meta';
import { Separator } from 'components/common/Separator';
import { BannerContent } from 'components/how-it-works/BannerContent';
import routes from 'constants/routes';
import { BaseLayout } from 'layouts/BaseLayout';
import { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { ReactElement, useEffect, useState } from 'react';
import { getApiBasepath } from '../../api';
import { useUserRegion } from 'hooks/useUserRegion';
import { Regions } from 'constants/regions';
import Trans from 'next-translate/Trans';
const Sellers = () => {
    const { t } = useTranslation('how_it_works');
    const [faqs, setFaqs] = useState<IFaq[]>();
    const getFaqs = async () => {
        const response = await fetch(`${getApiBasepath()}/api/faqs`);
        const data = await response.json();
        const howItWorksFaqs = data.data?.filter((faq: IFaq) => faq.attributes.page === 'SELLERS');
        setFaqs(howItWorksFaqs);
    };
    useEffect(() => {
        getFaqs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { userRegion } = useUserRegion();
    const isUS = userRegion === Regions.US;
    function buildTranslationKey(key: string) {
        if (isUS)
            return `${key}_us`;
        return key;
    }
    const translationComponents = {
        dhlLink: (<a href={isUS ? routes.dhlDropOffPointUS() : routes.dhlDropOffPoint()} className='text-secondary-default underline' target='_blank' rel='noreferrer'/>),
        collectionLink: (<Link href='/how-it-works/shipping#schedulePickup' className='text-secondary-default underline'/>),
        upsLink: (<a href={routes.ups} className='text-secondary-default underline' target='_blank' rel='noreferrer'/>)
    } as const;
    return (<>
      <Meta pageTitle={t('sellers_page_title')} pageDescription={t('sellers_page_desc')} imageName='social-hiw-sellers' relativeUrl={routes.howItWorks.forSellers}/>

      <main className='bg-warm-50'>
        <BannerHalfBlurred src='/images/banners/hiw-sellers.png' priority reversed loading='eager'>
          <BannerContent title={t('sellers_banner_title')} description={t('sellers_banner_description')}/>
        </BannerHalfBlurred>

        <section className='bg-warm-50 pb-8 pt-12 sm:pb-12 md:pt-16'>
          <div className='container flex justify-center'>
            <div className='w-full max-w-[1120px]'>
              <h6 className='text-center font-medium text-cool-900 md:hidden'>
                {t('why_sell')}
              </h6>
              <h5 className='hidden text-center font-medium text-cool-900 md:block lg:hidden'>
                {t('why_sell')}
              </h5>
              <h4 className='hidden text-center font-medium text-cool-900 lg:block'>
                {t('why_sell')}
              </h4>
              <p className='mt-4 text-center text-sm text-cool-600 md:text-base lg:text-lg xl:text-xl'>
                {t('it_may_seem_counterintuitive')}
              </p>
              <div className='-mx-2 -my-2 mt-8 grid  grid-cols-1 items-start md:grid-cols-2 lg:mt-12'>
                <FeatureCard className='col-span-1  mx-2 my-2' iconName='filled-timer' title={t('feature_cards_sellers.1_title')} shortDescription={t('feature_cards_sellers.1_description')} longDescription={<p className='text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_sellers.1_long_description_1')}
                      <br /> <br />
                      {t('feature_cards_sellers.1_long_description_2')}
                      <br />
                      <br />
                      {t('feature_cards_sellers.1_long_description_3')}
                      <br />
                      <br />
                      {t('feature_cards_sellers.1_long_description_4')}
                    </p>}/>
                <FeatureCard className='col-span-1 mx-2 my-2' iconName='filled-prize' title={t('feature_cards_sellers.2_title')} shortDescription={t('feature_cards_sellers.2_description')} longDescription={<p className='text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_sellers.2_long_description_1')}
                      <br />
                      <br />
                      {t('feature_cards_sellers.2_long_description_2')}{' '}
                      <Link href='/how-it-works/fees' className='text-secondary-default underline'>
                        {t('feature_cards_sellers.2_long_description_3')}
                      </Link>
                      .
                    </p>}/>
                <FeatureCard className='crown-icon col-span-1 mx-2 my-2' iconName='filled-royalty' title={t('feature_cards_sellers.3_title')} shortDescription={t('feature_cards_sellers.3_description')} longDescription={<p className='text-sm text-cool-600 md:text-base'>
                      {' '}
                      {t('feature_cards_sellers.3_long_description_1')}{' '}
                      <Link href='/how-it-works/for-artists' className='text-secondary-default underline'>
                        {t('learn_more')}
                      </Link>
                    </p>}/>
                <FeatureCard className='col-span-1 mx-2 my-2' iconName='filled-eye' title={t('feature_cards_sellers.4_title')} shortDescription={<p className='text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_sellers.4_description')}
                    </p>} longDescription={<p className='text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_sellers.4_long_description_1')}
                      <br />
                      <br />
                      {t('feature_cards_sellers.4_long_description_2')}
                      <br />
                      <br />
                      {t('feature_cards_sellers.4_long_description_3')}
                    </p>}/>
              </div>
            </div>
          </div>
        </section>

        <div className='container flex justify-center'>
          <Separator className='max-w-[1120px] bg-cool-400'/>
        </div>

        <section className='flex justify-center bg-warm-50 pb-16 pt-12 sm:pt-16'>
          <div className='container flex flex-col items-center'>
            <h4 className='mb-14 hidden font-normal sm:block'>
              {t('how')} <span className='font-bold'>{t('selling')}</span>{' '}
              {t('works')}
            </h4>
            <h5 className='mb-14 font-normal sm:hidden'>
              {t('how')} <span className='font-bold'>{t('selling')}</span>{' '}
              {t('works')}
            </h5>
            <div className='mb-8 flex flex-col items-center'>
              <InfoDot className='mb-3 min-h-[32px] w-8 bg-primary-default sm:min-h-[48px] sm:w-12'>
                <h5 className='hidden font-medium text-cool-150 sm:block'>1</h5>
                <h6 className='font-medium text-cool-150 sm:hidden'>1</h6>
              </InfoDot>
              <h5 className='mb-2 hidden font-medium text-cool-900 sm:block'>
                {t('sell_or_ask')}
              </h5>
              <h6 className='mb-2 font-medium text-cool-900 sm:hidden'>
                {t('sell_or_ask')}
              </h6>
              <p className='text-center text-sm text-cool-600 sm:text-base'>
                {t('the_power')} <br />
                {t('once_on_an_item_page_sell')}
              </p>
            </div>

            <HowItWorksStep src='/files/hiw-sell-now_2.png' alt='' imageClassName='max-h-[244px]  max-w-[176px]' title={t('how_it_works_sellers.1_title')} description={<p className='text-sm text-cool-600 lg:text-base'>
                  {t('how_it_works_sellers.1_description')}
                </p>} className='mb-6 max-w-[1120px]'/>

            <HowItWorksStep src='/files/hiw-list.png' alt='' imageClassName='max-w-[314px] max-h-[196px]' title={t('how_it_works_sellers.2_title')} description={<p className='text-sm text-cool-600 lg:text-base'>
                  {t('how_it_works_sellers.2_description_1')} <br />
                  <br /> {t('how_it_works_sellers.2_description_2')}
                </p>} className='mb-16 max-w-[1120px]'/>

            <div className='mb-8 flex flex-col items-center'>
              <InfoDot className='mb-3 min-h-[32px] w-8 bg-primary-default sm:min-h-[48px] sm:w-12'>
                <h5 className='hidden font-medium text-cool-150 sm:block'>2</h5>
                <h6 className='text-base font-medium text-cool-150 sm:hidden'>
                  2
                </h6>
              </InfoDot>
              <h5 className='hidden font-medium text-cool-900 sm:block'>
                {t('send_your_package')}
              </h5>
              <h6 className='font-medium text-cool-900 sm:hidden'>
                {t('send_your_package')}
              </h6>
            </div>

            <HowItWorksStep src='/files/hiw-shipping-step2.svg' alt='' reversed description={<div className='flex h-full flex-col justify-center'>
                  <div className='text-sm text-cool-600 lg:text-base'>
                    {t('how_it_works_sellers.3_description_1')} <br /> <br />
                    <p>
                      {t(buildTranslationKey('how_it_works_sellers.3_description'))}
                    </p>
                    <ol className='list-inside list-disc pl-3'>
                      <li>
                        <Trans i18nKey={buildTranslationKey('how_it_works:how_it_works_sellers.3_steps.1')} components={translationComponents}/>
                      </li>
                      <li>
                        <Trans i18nKey={buildTranslationKey('how_it_works:how_it_works_sellers.3_steps.2')} components={translationComponents}/>
                      </li>
                    </ol>
                    {isUS && (<p className='mt-4'>
                        <Trans i18nKey='how_it_works:how_it_works_sellers.3_additional_description_us' components={translationComponents}/>
                      </p>)}
                    <br /> {t('how_it_works_sellers.3_description_8')}{' '}
                    <a href='/files/fairart-shipping-guidance.pdf' className='text-secondary-default underline' target={'_blank'} rel='noreferrer'>
                      {t('how_it_works_sellers.3_description_9')}
                    </a>{' '}
                    {t('how_it_works_sellers.3_description_10')}
                  </div>
                </div>} className='mb-16 max-w-[1120px]'/>

            <div className='mb-8 flex flex-col items-center'>
              <InfoDot className='mb-3 min-h-[32px] w-8 bg-primary-default sm:min-h-[48px] sm:w-12'>
                <h5 className='hidden font-medium text-cool-150 sm:block'>3</h5>
                <h6 className='text-base font-medium text-cool-150 sm:hidden'>
                  3
                </h6>
              </InfoDot>
              <h5 className='hidden font-medium text-cool-900 sm:block'>
                {t('get_paid')}
              </h5>
              <h6 className='font-medium text-cool-900 sm:hidden'>
                {t('get_paid')}
              </h6>
            </div>

            <HowItWorksStep src='/files/hiw-shipping-step3.svg' alt='' description={<div className='flex h-full flex-col justify-center'>
                  <p className='text-sm text-cool-600 lg:text-base'>
                    {t('how_it_works_sellers.4_description_1')}
                  </p>
                </div>} className='max-w-[1120px]'/>
          </div>
        </section>

        <div className='container  flex justify-center'>
          <Separator className='max-w-[1120px] bg-cool-400'/>
        </div>

        {faqs && faqs.length > 0 && (<section className='bg-warm-50 pb-20 pt-12 md:pb-[72px]'>
            <h5 className='text-center font-medium md:hidden'>{t('faqs')}</h5>
            <h4 className='hidden text-center font-medium md:block'>
              {t('faqs')}
            </h4>
            <div className='container mt-8 flex justify-center'>
              <div className='-mx-2 -my-2 flex w-full max-w-[1120px] flex-col items-center justify-center'>
                {faqs.map((faq, index) => (<Collapsable key={index} type='faq' className='mx-2 my-2 w-full rounded-xl border border-solid border-cool-300 bg-cool-50 p-5 sm:p-8' title={faq.attributes.title ? (<Markdown className='font-medium sm:text-xl'>
                          {faq.attributes.title}
                        </Markdown>) : (<p>
                          Sorry, we don&apos;t have a question for this answer
                          yet. Try again later!
                        </p>)}>
                    <div className='mt-3 text-sm text-cool-600 sm:mt-4 sm:text-base'>
                      {faq.attributes.description ? (<Markdown className='custom-answer'>
                          {faq.attributes.description}
                        </Markdown>) : (<p>
                          Sorry, we don&apos;t have an answer yet. Try again
                          later!
                        </p>)}
                    </div>
                  </Collapsable>))}
              </div>
            </div>
          </section>)}

        <Banner type='blurred' src={{
            mobile: '/files/banners/artworks-bg5-small.jpg',
            desktop: '/files/banners/artworks-bg5-big.jpg'
        }} width={{ mobile: 768, desktop: 2265 }} height={{ mobile: 412, desktop: 791 }}/>
      </main>
    </>);
};
Sellers.getLayout = (page: ReactElement) => (<BaseLayout style='off-white-bg'>{page}</BaseLayout>);
const getStaticProps: GetStaticProps = async () => ({ props: {} });
export default Sellers;

    async function __Next_Translate__getStaticProps__19cd755509f__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/how-it-works/for-sellers',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19cd755509f__ as getStaticProps }
  